// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_mats = /** @type {(inputs: {}) => string} */ () => {
	return `Mats`
};

const el_mats = /** @type {(inputs: {}) => string} */ () => {
	return `Χαλάκια`
};

const ru_mats = /** @type {(inputs: {}) => string} */ () => {
	return `Коврики`
};

const he_mats = /** @type {(inputs: {}) => string} */ () => {
	return `מזרונים`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mats = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mats(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("mats", locale)
	if (locale === "en") return en_mats(inputs)
	if (locale === "el") return el_mats(inputs)
	if (locale === "ru") return ru_mats(inputs)
	if (locale === "he") return he_mats(inputs)
	return "mats"
};